import axios from 'axios';

const editShopInfo = (data) => {
  return axios
    .put(`${process.env.REACT_APP_API_URL}/api/dealer/${data._id}`, data)
    .then(res => res)
    .catch(err => err);
};

export default editShopInfo;
